import { createFileRoute } from '@tanstack/react-router';

import { StoresPage, storesQueryOptions } from '@/features/stores';

export const Route = createFileRoute('/_authed/_active/org/stores/')({
  staticData: { tours: ['org.stores'] },
  loader: ({ context }) =>
    context.queryClient
      .query({ ...storesQueryOptions(), staleTime: 'static' })
      .catch(() => undefined),
  component: StoresPage,
});
